export default __webpack_public_path__ + "static/media/onOffUsingFloatingBar.9267ccab.gif";